import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { boxedFacets, expandedFacets } from "../config"
import ColorFilters from "./elements/ColorFilters"
import BoxFilters from "./elements/BoxFilters"
import CheckboxFilters from "./elements/CheckboxFilters"
import { useEffect } from "preact/hooks"

export default function Facet({ facet }) {
    const { active, toggleActive, toggleProductFilter } = useFacet(facet);

    useEffect(() => {
        if(window.innerWidth > 768 && expandedFacets.includes(facet.name)) {
            toggleActive();
        }
    }, [])

    console.log(facet);

    return (
        <li class={`ns-facet ${active ? "ns-active" : ""}`}>
            <button
                type="button"
                class="ns-facet-dropdown-toggle"
                aria-expaned={active}
                aria-controls={`${facet.field}-facet`}
                data-nosto-element="facet"
                onClick={toggleActive}
                tabIndex="0"
            >
                <span class="ns-facet-dropdown-toggle-text">{facet.name}</span>
                <svg class="ns-facet-toggle-chevron" aria-hidden="true" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
                    <path d="M56 39.671c0 0.449-0.224 0.954-0.561 1.291l-2.806 2.806c-0.337 0.337-0.786 0.561-1.291 0.561-0.449 0-0.954-0.224-1.291-0.561l-22.052-22.052-22.052 22.052c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-2.806-2.806c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l26.148-26.148c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l26.148 26.148c0.337 0.337 0.561 0.842 0.561 1.291z"></path>
                </svg>
            </button>

            <div class="ns-facet-content" id={`${facet.field}-facet`}>
                {(facet.field === "customFields.cql-generic_colors") ? (
                    <ColorFilters
                        facet={facet} 
                        toggleProductFilter={toggleProductFilter}
                    />
                ) : (boxedFacets[facet.name]) ? (
                    <BoxFilters
                        toggleProductFilter={toggleProductFilter}
                        facet={facet}
                        columns={boxedFacets[facet.name]}
                    />                    
                ) : (
                    <CheckboxFilters
                        toggleProductFilter={toggleProductFilter}
                        facet={facet} 
                    />
                )}
            </div>
        </li>
    )
}
